module.exports = __webpack_public_path__ + "img/zender-wit.e87d4dd4.svg";